import type { Role } from '../../api/types';

export function roleLabel(role: Role): string {
  if (role === 'admin') return 'Администратор';
  if (role === 'organizer') return 'Организатор';
  return 'Пользователь';
}

export function canAccessAdmin(role: Role | null | undefined): boolean {
  return role === 'admin';
}
